'use strict';
/**
 *  Load modules
 */

import jBox from 'jbox';
import 'sticky-kit/dist/sticky-kit';
import '../scss/app.scss';
$(document).ready(function () {
  var browserWidth = window.innerWidth || document.documentElement.clientWidth; //hide/show mobile menu

  $('.hide_show_menu').click(function () {
    $("body").toggleClass("mobile-menu-active");
  }); // disable click for menu without link

  $('.no-click').click(function (e) {
    e.preventDefault();
  }); // Slider

  if ($('.slider').length > 0) {
    $('.slider').each(function (num, elem) {
      elem = $(elem);
      var count = elem.children().length;

      if (count > 4 || count > 2 && browserWidth < 1025 || count > 1 && browserWidth < 641) {
        elem.slick({
          slidesToShow: count > 4 ? 4 : count,
          slidesToScroll: count > 4 ? 4 : count,
          arrows: false,
          dots: count > 4 ? true : false,
          infinite: true,
          adaptiveHeight: true,
          responsive: [{
            breakpoint: 1025,
            settings: {
              adaptiveHeight: true,
              dots: count > 3 ? true : false,
              slidesToShow: count > 3 ? 3 : count,
              slidesToScroll: count > 3 ? 3 : count
            }
          }, {
            breakpoint: 641,
            settings: {
              adaptiveHeight: true,
              dots: count > 2 ? true : false,
              slidesToShow: count > 2 ? 2 : count,
              slidesToScroll: count > 2 ? 2 : count
            }
          }]
        });
        elem.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          tooltipJBox.close();
        });
      }

      $(window).on('resize orientationchange', function () {
        elem.slick('refresh');
      });
    });
  } // linkedin-feed slider

  /*if ($('.linkedin-feed__list').length > 0) {
      const count = $('.linkedin-feed__list').children().length;
      $('.linkedin-feed__list').slick({
          arrows: false,
          dots:  count > 3 ? true : false,
          infinite: false,
          adaptiveHeight: false,
          swipe: true,
          variableWidth: true,
          slidesToShow: 3,
          responsive: [
              {
                  breakpoint: 1670,
                  settings: {
                      swipe: true,
                      dots: count > 2 ? true : false,
                      slidesToShow: 2,
                  }
              },
              {
                  breakpoint: 1140,
                  settings: {
                      swipe: true,
                      dots: count > 1 ? true : false,
                      slidesToShow: 1,
                      adaptiveHeight: true
                  }
              }
          ]
      });
      $(window).on('resize orientationchange', function() {
          $('.linkedin-feed__list').slick('refresh');
      });
  }*/
  //jBox Tooltip init


  var tooltipJBox = new jBox('Tooltip', {
    trigger: 'click',
    maxWidth: 450,
    minWidth: 300,
    attach: '.with-tooltip',
    getTitle: 'data-title',
    getContent: 'data-content',
    closeButton: 'title'
  }); //jBox Modal for Vacancy

  new jBox('Modal', {
    content: $('#vacancyModal'),
    attach: '.vacancyButton',
    getTitle: 'data-title',
    closeButton: 'title',
    addClass: 'jBox-vacancy',
    maxWidth: 400,
    onOpenComplete: function onOpenComplete() {
      if ($('#vacancyname').length > 0) {
        $('#vacancyname').val(this.source[0].dataset.vacancyName);
      }
    },
    onClose: function onClose() {
      $("#clear-form-btn").trigger('click');
      $attachInfo.removeClass('showed');
    }
  }); //smooth scroll

  $(".smooth-scroll").click(function (e) {
    e.preventDefault();
    var id = $(this).attr('href');
    $('html,body').animate({
      scrollTop: $(id).offset().top - 80
    }, 500);
  }); //board slider

  if (browserWidth < 1200 && $('.board-slider').length > 0) {
    var sliderLength = $('.board-slider > div').length;
    $('.board-slider').slick({
      dots: sliderLength > 3 ? true : false,
      arrows: false,
      swipe: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 640,
        settings: {
          dots: sliderLength > 2 ? true : false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          dots: sliderLength > 1 ? true : false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
    $('.board-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      $(".tab__slider").slick('refresh');
    });
  } //team slider


  if (browserWidth < 1200 && $('.team-slider').length > 0) {
    var _sliderLength = $('.team-slider > div').length;

    if (_sliderLength > 1) {
      $(".team-slider").slick({
        dots: _sliderLength > 8 ? true : false,
        arrows: false,
        swipe: true,
        rows: 2,
        infinite: false,
        slidesPerRow: 4,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [{
          breakpoint: 560,
          settings: {
            dots: _sliderLength > 6 ? true : false,
            slidesPerRow: 3
          }
        }, {
          breakpoint: 420,
          settings: {
            dots: _sliderLength > 4 ? true : false,
            slidesPerRow: 2
          }
        }]
      });
      $('.team-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(".tab__slider").slick('refresh');
      });
    }
  }

  var tab_slider; //tab slider

  if ($('.tab__slider').length > 0) {
    tab_slider = $(".tab__slider").slick({
      dots: true,
      arrows: false,
      infinite: false,
      swipe: false,
      fade: true,
      cssEase: 'linear',
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      customPaging: function customPaging(slider, i) {
        var title = $(slider.$slides[i]).data('title');
        return '<div class="tab-dots__item"> ' + title + ' </div>';
      }
    });
    tab_slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      tooltipJBox.close();
    });
    $('.tab__slider details').on('click', function () {
      tab_slider.slick('refresh');
    });
  } //news events slider


  if (browserWidth < 768 && $('.news-events__slider').length > 0) {
    $(".news-events__slider").slick({
      dots: true,
      arrows: false,
      infinite: false,
      swipe: true,
      fade: true,
      cssEase: 'linear',
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      customPaging: function customPaging(slider, i) {
        var title = $(slider.$slides[i]).data('title');
        return '<div class="tab-dots__item"> ' + title + ' </div>';
      }
    });
  } // Accordion


  $('.accordion__header').on('click', function () {
    var target = $(this),
        clickedID = target.data('id');
    target.parents('.accordion').find('.accordion__header').removeClass('active');
    target.parents('.accordion').find('.accordion__content').each(function () {
      if ($(this).data('id') == clickedID) {
        $(this).addClass('active');
        $(this).fadeIn();
      } else {
        $(this).fadeOut(0);
        $(this).removeClass('active');
      }
    });
    $(this).addClass('active');
  }); // Vacancies open/close

  $('.vacancy__header').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  }); //smooth scroll for faq links

  $(".faq__menu-link").click(function (e) {
    e.preventDefault();
    $(this).parents('.faq').find('.faq__menu-link').removeClass('active');
    $(this).addClass('active');
    var id = $(this).attr('href');
    $('html,body').animate({
      scrollTop: $(id).offset().top - 100
    }, 500);
  }); //sticky column

  if ($('.is-sticky').length > 0 && browserWidth > 960) {
    $(".is-sticky").stick_in_parent({
      offset_top: 100
    });
  } // Close cookies message


  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  }

  var $cookieMessage = $(".cookie-message");
  $(".cookie-message__close").click(function (e) {
    e.preventDefault();
    var d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = "agreeewithcook=1; " + expires + "; path=/";
    $cookieMessage.animate({
      bottom: '-100%'
    }, 500, function () {
      $cookieMessage.remove();
    });
  });
  var agreeewithcook = readCookie('agreeewithcook');

  if (!agreeewithcook) {
    $cookieMessage.addClass('show');
  } else {
    $cookieMessage.remove();
  } // form file attach


  var $attachInfo = $('.form__controll--attach-info');
  $(".form__controll--attach input[type='file']").change(function () {
    var value = $(this).val().replace(/^.*[\\\/]/, ''),
        $attachText = $('.form__controll--attach-text');
    $attachText.text(value);

    if (value === '') {
      $attachInfo.removeClass('showed');
    } else {
      $attachInfo.addClass('showed');
    }
  });
  $(".form__controll--attach-remove").on('click', function (event) {
    $(".form__controll--attach input[type='file']").val('');
    $attachInfo.removeClass('showed');
  }); // form fields not empty

  var forminput = $('.form input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=image]):not([type=file]), :not(.uploadfile) input, .form textarea');
  forminput.on('blur', function () {
    if ($(this).val().length > 0) {
      $(this).addClass('not-empty').removeClass('empty');
    } else {
      $(this).removeClass('not-empty').addClass('empty');
    }
  });
  document.addEventListener('wpcf7submit', function (event) {
    forminput.removeClass('empty').removeClass('not-empty');
  }, false);
});